// @ts-nocheck
import Messenger from "../common/Messenger"

const TranslatorMessenger = (props) => {
    return (
        <Messenger {...props} />
    )
}

export default TranslatorMessenger